import type { ReactNode } from 'react';

export const symbol_assistant_device: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M373.5-621.5Q330-578 330-515t43.5 106.5Q417-365 480-365t106.5-43.5Q630-452 630-515t-43.5-106.5Q543-665 480-665t-106.5 43.5ZM480-425q-39 0-64.5-25.5T390-515q0-39 25.5-64.5T480-605q39 0 64.5 25.5T570-515q0 39-25.5 64.5T480-425Zm198 158q12-12 12-28t-12-28q-12-12-28-12t-28 12q-12 12-12 28t12 28q12 12 28 12t28-12ZM160-140v-550q0-79 55.5-134.5T350-880h260q79 0 134.5 55.5T800-690v550q0 25-17.5 42.5T740-80H220q-25 0-42.5-17.5T160-140Zm60-65h520v-485q0-55-37.5-92.5T610-820H350q-55 0-92.5 37.5T220-690v485Zm33 0h487-520 33Zm-33 0h520-520Z"
		/>
	</svg>
);
